// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Google+Sans+Code:ital@0;1&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
*::before,
*::after {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
}

:root {
    --fallback-font: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
    --main-font-family: "Google Sans Code";

    /* palette */
    --viridian: #6B9080;
    --cambridge-blue: #A4C3B2;
    --mint-green: #CCE3DE;
    --azure: #EAF4F4;
    --mint-cream: #F6FFF8;
    --chili-red: #D64933;
}

html,
body {
    height: 100%;
    width: 100%;
}

body {
    font-family: var(--main-font-family), var(--fallback-font);
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: 5em 8fr 4em;
}

/* header section */
.header {
    background-color: var(--mint-green);
    padding-left: 10px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 5px;
}

.todo-icon {
    width: 32px;
    height: 32px;
}

/* main section */
.main-section {
    display: grid;
    grid-template-columns: 2fr 6fr;
}

/* side bar section */
.side-bar-container {
    background-color: var(--azure);
    padding: 12px;
    list-style: none;
    font-size: 1.6rem;
}

.sidebar-menu-item {
    background-color: var(--mint-green);
    margin-bottom: 12px;
    padding: 8px;
    border-radius: 5px;
    display: flex;
    justify-content: space-between;
}

.sidebar-menu-item:hover {
    border: 2px solid var(--mint-green);
    border: 1px solid var(--viridian);
    cursor: pointer;
}

.sidebar-highlight {
    background-color: var(--viridian);
}

.projects-hdr-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 5px;
    gap: 2px;
    border-bottom: 1px solid var(--viridian);
}

.add-project-icon {
    font-size: 3rem;
    color: var(--viridian);
    padding-right: 5px;
    padding-bottom: 5px;
    user-select: none;
}

.add-project-icon:hover {
    cursor: pointer;
    -webkit-text-stroke: 3px var(--mint-green);
}

.project-container {
    margin-top: 10px;
}

.project-btn-wrapper {
    display: flex;
    gap: 5px;
}

/* main section - Todos */
.todos-container {
    padding: 20px;
}

.main-title {
    display: flex;
    justify-content: center;
    font-size: 2.2rem;
    text-decoration: underline 3px var(--mint-green);
    text-decoration-skip-ink: none;
    text-underline-offset: 8px;
}

.empty-todo {
    display: flex;
    justify-content: center;
    font-size: 1.6rem;
    margin-top: 15px;
}

.add-task-btn {
    font-size: 1.3rem;
    padding: 5px;
    border-radius: 6px;
    border: 3px solid var(--cambridge-blue);
    background: none;
}

.task-modal,
.project-modal {
    background-color: var(--azure);
    margin: auto;
    border-radius: 10px;

}

.task-form-header,
.project-form-header {
    background-color: var(--cambridge-blue);
    padding: 1rem;
    color: var(--azure);
}

.task-form-wrapper {
    padding: 1.5rem 2rem 0;
}

.project-input-wrapper {
    padding: 1rem 1rem 0;
}

.task-input,
.project-input {
    width: 100%;
    border: 2px solid var(--viridian);
    background: none;
    padding: 10px;
    border-radius: 10px;
    font-size: 1rem;
}

.task-input:focus {
    background-color: var(--mint-cream);
}

.task-form-btn-wrapper {
    padding-bottom: 1rem;
    display: flex;
    justify-content: space-between;
}

.project-form-btn-wrapper {
    display: flex;
    justify-content: space-between;
    padding: 0.7rem 1rem;
}

.cancel-btn {
    background-color: var(--mint-green);
    font-size: 1.1rem;
    padding: 5px;
    border-radius: 6px;
    border: 0;
}

.task-item {
    background-color: var(--mint-green);
    margin-top: 10px;
    padding: 10px;
    display: flex;
    justify-content: space-between;
    /* wrap on small screens */
    flex-wrap: wrap;
    gap: 5px;
}

.task-wrapper-left {
    display: flex;
    align-items: center;
    gap: 5px;
}

.complete-toggle {
    /* Remove checkbox native input styles */
    appearance: none;
    width: 1.2rem;
    height: 1.2rem;
    border: 2px solid var(--viridian);
    display: grid;
    align-content: center;
    justify-content: center;
}

.complete-toggle::before {
    content: "";
    width: 0.7rem;
    height: 0.7rem;
    clip-path: polygon(15% 45%, 0 65%, 50% 100%, 100% 16%, 80% 0%, 45% 62%);
    transform: scale(0);
    background-color: var(--chili-red);
}

.complete-toggle:checked:before {
    transform: scale(1);
}

.task-complete {
    text-decoration: line-through;
}

.task-wrapper-right {
    display: flex;
    align-items: center;
    gap: 10px;
}

.task-item:hover {
    box-shadow: 2px 2px 1px 1px var(--viridian);
    transform: scale(1.02);
}

.close-detail-btn,
.submit-task-btn,
.submit-project-btn {
    background: linear-gradient(to bottom right, var(--viridian), var(--mint-cream));
    font-size: 1.1rem;
    padding: 5px;
    border-radius: 6px;
    border: 0;
}

.delete-btn,
.edit-btn,
.detail-btn {
    background: none;
    border: 0;
    display: flex;
    align-items: center;
    justify-content: center;
}

.detail-icon,
.edit-icon {
    width: 28px;
    height: 28px;
    filter: invert(55%) sepia(18%) saturate(1000%) hue-rotate(102deg) brightness(100%) contrast(100%);
}

.delete-icon {
    width: 28px;
    height: 28px;
    filter: invert(23%) sepia(94%) saturate(6110%) hue-rotate(0deg) brightness(95%) contrast(90%);
}

.close-detail-btn:hover,
.submit-task-btn:hover,
.cancel-btn:hover,
.add-task-btn:hover,
.submit-project-btn:hover {
    filter: brightness(120%);
    cursor: pointer;
}

.detail-btn:hover,
.edit-btn:hover,
.delete-btn:hover {
    filter: brightness(110%);
    cursor: pointer;
    background: var(--mint-green);
}

.todo-detail-modal {
    background-color: var(--azure);
    margin: auto;
    width: 50%;
    padding: 10px;
    font-size: 1.2rem;
    border-radius: 5px;
    border: none;
    position: relative;
}

.todo-detail-modal::backdrop,
.task-modal::backdrop {
    backdrop-filter: blur(3px);
}

.x-sign-close-btn {
    position: absolute;
    font-size: 1.7rem;
    right: 1rem;
    top: 0.4rem;
    background-color: transparent;
    border: none;
}

.x-sign-close-btn:hover {
    cursor: pointer;
    color: var(--viridian);
}

.todo-detail-para {
    padding: 10px;
}

.close-detail-btn {
    margin-top: 5px;
}

/* footer section*/
.footer {
    background-color: var(--cambridge-blue);
    font-size: 1.3rem;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
}

.github-icon {
    height: 30px;
    width: 30px;
}

.github-icon:hover {
    transform: scale(1.2) rotate(180deg);
}`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAEA;;;IAGI,sBAAsB;IACtB,SAAS;IACT,UAAU;AACd;;AAEA;IACI,uJAAuJ;IACvJ,sCAAsC;;IAEtC,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;IACzB,qBAAqB;IACrB,gBAAgB;IAChB,qBAAqB;IACrB,oBAAoB;AACxB;;AAEA;;IAEI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,0DAA0D;IAC1D,aAAa;IACb,0BAA0B;IAC1B,+BAA+B;AACnC;;AAEA,mBAAmB;AACnB;IACI,mCAAmC;IACnC,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA,iBAAiB;AACjB;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA,qBAAqB;AACrB;IACI,8BAA8B;IAC9B,aAAa;IACb,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,mCAAmC;IACnC,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,mCAAmC;IACnC,iCAAiC;IACjC,eAAe;AACnB;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,cAAc;IACd,QAAQ;IACR,wCAAwC;AAC5C;;AAEA;IACI,eAAe;IACf,sBAAsB;IACtB,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,0CAA0C;AAC9C;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA,yBAAyB;AACzB;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,iBAAiB;IACjB,gDAAgD;IAChD,8BAA8B;IAC9B,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,uCAAuC;IACvC,gBAAgB;AACpB;;AAEA;;IAEI,8BAA8B;IAC9B,YAAY;IACZ,mBAAmB;;AAEvB;;AAEA;;IAEI,uCAAuC;IACvC,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,oBAAoB;AACxB;;AAEA;;IAEI,WAAW;IACX,iCAAiC;IACjC,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,oBAAoB;IACpB,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,oBAAoB;AACxB;;AAEA;IACI,mCAAmC;IACnC,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,mCAAmC;IACnC,gBAAgB;IAChB,aAAa;IACb,aAAa;IACb,8BAA8B;IAC9B,0BAA0B;IAC1B,eAAe;IACf,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,wCAAwC;IACxC,gBAAgB;IAChB,aAAa;IACb,cAAc;IACd,iCAAiC;IACjC,aAAa;IACb,qBAAqB;IACrB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,aAAa;IACb,cAAc;IACd,uEAAuE;IACvE,mBAAmB;IACnB,kCAAkC;AACtC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,2CAA2C;IAC3C,sBAAsB;AAC1B;;AAEA;;;IAGI,gFAAgF;IAChF,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,SAAS;AACb;;AAEA;;;IAGI,gBAAgB;IAChB,SAAS;IACT,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;;IAEI,WAAW;IACX,YAAY;IACZ,iGAAiG;AACrG;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,6FAA6F;AACjG;;AAEA;;;;;IAKI,wBAAwB;IACxB,eAAe;AACnB;;AAEA;;;IAGI,wBAAwB;IACxB,eAAe;IACf,6BAA6B;AACjC;;AAEA;IACI,8BAA8B;IAC9B,YAAY;IACZ,UAAU;IACV,aAAa;IACb,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;;IAEI,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,WAAW;IACX,WAAW;IACX,6BAA6B;IAC7B,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;AACnB;;AAEA,kBAAkB;AAClB;IACI,uCAAuC;IACvC,iBAAiB;IACjB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,oCAAoC;AACxC","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Google+Sans+Code:ital@0;1&display=swap');\r\n\r\n*,\r\n*::before,\r\n*::after {\r\n    box-sizing: border-box;\r\n    margin: 0;\r\n    padding: 0;\r\n}\r\n\r\n:root {\r\n    --fallback-font: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;\r\n    --main-font-family: \"Google Sans Code\";\r\n\r\n    /* palette */\r\n    --viridian: #6B9080;\r\n    --cambridge-blue: #A4C3B2;\r\n    --mint-green: #CCE3DE;\r\n    --azure: #EAF4F4;\r\n    --mint-cream: #F6FFF8;\r\n    --chili-red: #D64933;\r\n}\r\n\r\nhtml,\r\nbody {\r\n    height: 100%;\r\n    width: 100%;\r\n}\r\n\r\nbody {\r\n    font-family: var(--main-font-family), var(--fallback-font);\r\n    display: grid;\r\n    grid-template-columns: 1fr;\r\n    grid-template-rows: 5em 8fr 4em;\r\n}\r\n\r\n/* header section */\r\n.header {\r\n    background-color: var(--mint-green);\r\n    padding-left: 10px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: flex-start;\r\n    gap: 5px;\r\n}\r\n\r\n.todo-icon {\r\n    width: 32px;\r\n    height: 32px;\r\n}\r\n\r\n/* main section */\r\n.main-section {\r\n    display: grid;\r\n    grid-template-columns: 2fr 6fr;\r\n}\r\n\r\n/* side bar section */\r\n.side-bar-container {\r\n    background-color: var(--azure);\r\n    padding: 12px;\r\n    list-style: none;\r\n    font-size: 1.6rem;\r\n}\r\n\r\n.sidebar-menu-item {\r\n    background-color: var(--mint-green);\r\n    margin-bottom: 12px;\r\n    padding: 8px;\r\n    border-radius: 5px;\r\n    display: flex;\r\n    justify-content: space-between;\r\n}\r\n\r\n.sidebar-menu-item:hover {\r\n    border: 2px solid var(--mint-green);\r\n    border: 1px solid var(--viridian);\r\n    cursor: pointer;\r\n}\r\n\r\n.sidebar-highlight {\r\n    background-color: var(--viridian);\r\n}\r\n\r\n.projects-hdr-wrapper {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    padding: 0 5px;\r\n    gap: 2px;\r\n    border-bottom: 1px solid var(--viridian);\r\n}\r\n\r\n.add-project-icon {\r\n    font-size: 3rem;\r\n    color: var(--viridian);\r\n    padding-right: 5px;\r\n    padding-bottom: 5px;\r\n    user-select: none;\r\n}\r\n\r\n.add-project-icon:hover {\r\n    cursor: pointer;\r\n    -webkit-text-stroke: 3px var(--mint-green);\r\n}\r\n\r\n.project-container {\r\n    margin-top: 10px;\r\n}\r\n\r\n.project-btn-wrapper {\r\n    display: flex;\r\n    gap: 5px;\r\n}\r\n\r\n/* main section - Todos */\r\n.todos-container {\r\n    padding: 20px;\r\n}\r\n\r\n.main-title {\r\n    display: flex;\r\n    justify-content: center;\r\n    font-size: 2.2rem;\r\n    text-decoration: underline 3px var(--mint-green);\r\n    text-decoration-skip-ink: none;\r\n    text-underline-offset: 8px;\r\n}\r\n\r\n.empty-todo {\r\n    display: flex;\r\n    justify-content: center;\r\n    font-size: 1.6rem;\r\n    margin-top: 15px;\r\n}\r\n\r\n.add-task-btn {\r\n    font-size: 1.3rem;\r\n    padding: 5px;\r\n    border-radius: 6px;\r\n    border: 3px solid var(--cambridge-blue);\r\n    background: none;\r\n}\r\n\r\n.task-modal,\r\n.project-modal {\r\n    background-color: var(--azure);\r\n    margin: auto;\r\n    border-radius: 10px;\r\n\r\n}\r\n\r\n.task-form-header,\r\n.project-form-header {\r\n    background-color: var(--cambridge-blue);\r\n    padding: 1rem;\r\n    color: var(--azure);\r\n}\r\n\r\n.task-form-wrapper {\r\n    padding: 1.5rem 2rem 0;\r\n}\r\n\r\n.project-input-wrapper {\r\n    padding: 1rem 1rem 0;\r\n}\r\n\r\n.task-input,\r\n.project-input {\r\n    width: 100%;\r\n    border: 2px solid var(--viridian);\r\n    background: none;\r\n    padding: 10px;\r\n    border-radius: 10px;\r\n    font-size: 1rem;\r\n}\r\n\r\n.task-input:focus {\r\n    background-color: var(--mint-cream);\r\n}\r\n\r\n.task-form-btn-wrapper {\r\n    padding-bottom: 1rem;\r\n    display: flex;\r\n    justify-content: space-between;\r\n}\r\n\r\n.project-form-btn-wrapper {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    padding: 0.7rem 1rem;\r\n}\r\n\r\n.cancel-btn {\r\n    background-color: var(--mint-green);\r\n    font-size: 1.1rem;\r\n    padding: 5px;\r\n    border-radius: 6px;\r\n    border: 0;\r\n}\r\n\r\n.task-item {\r\n    background-color: var(--mint-green);\r\n    margin-top: 10px;\r\n    padding: 10px;\r\n    display: flex;\r\n    justify-content: space-between;\r\n    /* wrap on small screens */\r\n    flex-wrap: wrap;\r\n    gap: 5px;\r\n}\r\n\r\n.task-wrapper-left {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 5px;\r\n}\r\n\r\n.complete-toggle {\r\n    /* Remove checkbox native input styles */\r\n    appearance: none;\r\n    width: 1.2rem;\r\n    height: 1.2rem;\r\n    border: 2px solid var(--viridian);\r\n    display: grid;\r\n    align-content: center;\r\n    justify-content: center;\r\n}\r\n\r\n.complete-toggle::before {\r\n    content: \"\";\r\n    width: 0.7rem;\r\n    height: 0.7rem;\r\n    clip-path: polygon(15% 45%, 0 65%, 50% 100%, 100% 16%, 80% 0%, 45% 62%);\r\n    transform: scale(0);\r\n    background-color: var(--chili-red);\r\n}\r\n\r\n.complete-toggle:checked:before {\r\n    transform: scale(1);\r\n}\r\n\r\n.task-complete {\r\n    text-decoration: line-through;\r\n}\r\n\r\n.task-wrapper-right {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 10px;\r\n}\r\n\r\n.task-item:hover {\r\n    box-shadow: 2px 2px 1px 1px var(--viridian);\r\n    transform: scale(1.02);\r\n}\r\n\r\n.close-detail-btn,\r\n.submit-task-btn,\r\n.submit-project-btn {\r\n    background: linear-gradient(to bottom right, var(--viridian), var(--mint-cream));\r\n    font-size: 1.1rem;\r\n    padding: 5px;\r\n    border-radius: 6px;\r\n    border: 0;\r\n}\r\n\r\n.delete-btn,\r\n.edit-btn,\r\n.detail-btn {\r\n    background: none;\r\n    border: 0;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n\r\n.detail-icon,\r\n.edit-icon {\r\n    width: 28px;\r\n    height: 28px;\r\n    filter: invert(55%) sepia(18%) saturate(1000%) hue-rotate(102deg) brightness(100%) contrast(100%);\r\n}\r\n\r\n.delete-icon {\r\n    width: 28px;\r\n    height: 28px;\r\n    filter: invert(23%) sepia(94%) saturate(6110%) hue-rotate(0deg) brightness(95%) contrast(90%);\r\n}\r\n\r\n.close-detail-btn:hover,\r\n.submit-task-btn:hover,\r\n.cancel-btn:hover,\r\n.add-task-btn:hover,\r\n.submit-project-btn:hover {\r\n    filter: brightness(120%);\r\n    cursor: pointer;\r\n}\r\n\r\n.detail-btn:hover,\r\n.edit-btn:hover,\r\n.delete-btn:hover {\r\n    filter: brightness(110%);\r\n    cursor: pointer;\r\n    background: var(--mint-green);\r\n}\r\n\r\n.todo-detail-modal {\r\n    background-color: var(--azure);\r\n    margin: auto;\r\n    width: 50%;\r\n    padding: 10px;\r\n    font-size: 1.2rem;\r\n    border-radius: 5px;\r\n    border: none;\r\n    position: relative;\r\n}\r\n\r\n.todo-detail-modal::backdrop,\r\n.task-modal::backdrop {\r\n    backdrop-filter: blur(3px);\r\n}\r\n\r\n.x-sign-close-btn {\r\n    position: absolute;\r\n    font-size: 1.7rem;\r\n    right: 1rem;\r\n    top: 0.4rem;\r\n    background-color: transparent;\r\n    border: none;\r\n}\r\n\r\n.x-sign-close-btn:hover {\r\n    cursor: pointer;\r\n    color: var(--viridian);\r\n}\r\n\r\n.todo-detail-para {\r\n    padding: 10px;\r\n}\r\n\r\n.close-detail-btn {\r\n    margin-top: 5px;\r\n}\r\n\r\n/* footer section*/\r\n.footer {\r\n    background-color: var(--cambridge-blue);\r\n    font-size: 1.3rem;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    gap: 10px;\r\n}\r\n\r\n.github-icon {\r\n    height: 30px;\r\n    width: 30px;\r\n}\r\n\r\n.github-icon:hover {\r\n    transform: scale(1.2) rotate(180deg);\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
